import { http } from "../api";
const easyUnpack = ({ data }) => data;
export const LassieOrganizationUserApi = {
    remove_user_from_organization: {
        f: function remove_user_from_organization(target_user_id, organization_id) {
            let url = '/lassie/organization/user/$target_user_id';
            let parameterNames = ["$target_user_id"];
            [target_user_id].forEach((parameterValue, index) => {
                url = url.replace(parameterNames[index], parameterValue)
            })
            return http.delete(url, { data: { organization_id } }).then(easyUnpack)
        }
    },
    copy_user_settings: {
        f: function copy_user_settings(source_user_id, target_user_ids) {
            let url = '/lassie/organization/user/copy-settings';
            return http.post(url, { source_user_id, target_user_ids }).then(easyUnpack)
        }
    },
    create_user: {
        f: function create_user(user_name, email, windfarm_ids, is_admin, organization_id) {
            let url = '/lassie/organization/user/';
            return http.post(url, { user_name, email, windfarm_ids, is_admin, organization_id }).then(easyUnpack)
        }
    },
    update_user_access_role: {
        f: function update_user_access_role(target_user_id, windfarm_id, role) {
            let url = '/lassie/organization/user/role';
            return http.post(url, { target_user_id, windfarm_id, role }).then(easyUnpack)
        }
    },
    remove_user_access_role: {
        f: function remove_user_access_role(target_user_id, windfarm_id) {
            let url = '/lassie/organization/user/role';
            return http.delete(url, { data: { target_user_id, windfarm_id } }).then(easyUnpack)
        }
    },
    update_user_admin_status: {
        f: function update_user_admin_status(target_user_id, is_admin) {
            let url = '/lassie/organization/user/admin';
            return http.patch(url, { target_user_id, is_admin }).then(easyUnpack)
        }
    },
};
